import { PropTypes } from 'prop-types';
import React from 'react';

import { COLORS } from '../../constants/colors';
import { transformCardImageBasedXLargeData } from '../../utils';
import CardImageBasedXLargeFullWidth from '../Cards/CardImageBased/CardImageBasedXLargeFullWidth';
import TitleStrip from '../Titles/TitleStrip';

const TITLE = 'Latest from Courier';
const LINK = {
  title: 'View More',
  url: 'https://couriermedia.com/shop/',
};
const THEME = {
  backgroundColor: COLORS.french,
  color: COLORS.peach,
};

const HomepageLatestFromCourier = ({ carousel: _carousel }) => {
  const carousel = transformCardImageBasedXLargeData(_carousel);

  return (
    <div
      className="maxed:mx-auto maxed:w-[1920px] maxed:border-r maxed:border-l border-smoke bg-snow relative"
      data-module-id="homepage_latest_from_courier"
    >
      <TitleStrip link={LINK} title={TITLE} variant />
      <div className="xl:w-[1440px] xl:mx-auto">
        <CardImageBasedXLargeFullWidth carousel={carousel} theme={THEME} />
      </div>
    </div>
  );
};

HomepageLatestFromCourier.propTypes = {
  carousel: PropTypes.array,
};

export default HomepageLatestFromCourier;
